import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Collapse } from 'react-collapse';
import { withStyles } from 'theme/withStyles';
import Field from 'containers/Field';

import Checkmark from './components/Checkmark';
import Subtext from './components/Subtext';
import Content from './components/Content';
import DetailHandle from './components/DetailHandle';
import Label from './components/Label';

const styles = {};

const DemandDeposit = ({
  fieldChosen,
  isInAllBundle,
  name,
  offerLabelText,
  rates,
  showOffersDetails,
  subText,
}) => {
  const [collapsed, setCollapse] = useState(!showOffersDetails);

  return (
    <>
      {!isInAllBundle ? <Checkmark name={name} /> : <Label label={offerLabelText} />}
      <DetailHandle setCollapse={setCollapse} collapsed={collapsed} />
      <Collapse isOpened={!collapsed}>
        <Content fieldChosen={fieldChosen} collapsed={collapsed}>
          <Subtext className="content">{subText}</Subtext>
          {rates && <Field fieldName={rates} groupName={name} />}
        </Content>
      </Collapse>
    </>
  );
};

DemandDeposit.propTypes = {
  fieldChosen: PropTypes.string.isRequired,
  isInAllBundle: PropTypes.bool,
  name: PropTypes.string.isRequired,
  offerLabelText: PropTypes.string,
  rates: PropTypes.string,
  showOffersDetails: PropTypes.bool.isRequired,
  subText: PropTypes.string,
};

DemandDeposit.defaultProps = {
  isInAllBundle: false,
  offerLabelText: '',
  rates: '',
  subText: '',
};

const DemandDepositBase = withStyles(styles)(DemandDeposit);

const mapDispatchToProps = ({ configs, offers }, { name }) => {
  const offer = offers[name] || {};
  return {
    fieldChosen: offer.fieldChosen,
    offerLabelText: offer.label,
    rates: offer.rates,
    showOffersDetails: configs.showOffersDetails,
    subText: offer.subText,
  };
};

export default connect(mapDispatchToProps)(DemandDepositBase);
